module.exports = __webpack_public_path__ + "img/createaccount-icon.92989950.svg";